import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThreddGroup = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "a",
			width: 12,
			height: 15,
			x: 32,
			y: 73,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fecfc4",
				d: "m43.126 73.365-3 14.21c-2.715.103-5.397-.717-7.722-2.359l2-9.33z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#a)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M30.719 80.912h4.332v-5.06H30.72z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M30.719 85.972h4.332v-5.06H30.72z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M30.719 75.852h4.332v-5.06H30.72z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M39.384 75.852h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.333zm0 5.06h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M39.384 80.912h4.333v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M39.384 85.972h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.333zm-4.333 5.059h4.332v-5.06H30.72z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M39.384 91.031h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.333z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "b",
			width: 60,
			height: 39,
			x: 16,
			y: 42,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fecfc4",
				d: "m73.887 50.737-4.812 6.37L62.78 51.2l4.029-7.215c-.535-.405-1.07-.833-1.624-1.272l-7.86 13.91H42.453c-1.122 0-2.212.438-3.096 1.244-.885.807-1.513 1.935-1.785 3.206l-.218 1.006c-.069.035-20.592 9.632-20.592 9.632-.05 3.142.926 6.188 2.732 8.519l18.791-7.342c3.872.419 16.146 1.572 20.167.983 4.013-.584 6.84-5.092 7.732-9.019l9.119-12.499z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#b)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M13.389 50.554h4.332v-5.06H13.39z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M13.389 55.613h4.332v-5.06H13.39z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M13.389 45.494h4.332v-5.06H13.39z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M22.054 45.494h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M17.721 45.494h4.333v-5.06H17.72zm12.998 5.06h4.332v-5.06H30.72zm-12.998 0h4.333v-5.06H17.72z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M30.719 55.613h4.332v-5.06H30.72zm-4.333 0h4.333v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M30.719 45.494h4.332v-5.06H30.72zm-4.333 0h4.333v-5.06h-4.333zm0 5.06h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M22.054 55.613h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M17.721 55.613h4.333v-5.06H17.72z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M56.714 45.494h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332zm12.998 5.06h4.332v-5.06h-4.333zm-12.998 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M65.38 55.613h4.332v-5.06h-4.333zm-4.333 0h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M65.38 45.494h4.332v-5.06h-4.333zm-4.333 0h4.332v-5.06h-4.333zm0 5.06h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M56.714 50.554h4.333v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M56.714 55.613h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M39.384 45.494h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.333zm12.997 5.06h4.333v-5.06h-4.333zm-12.997 0h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M48.049 55.613h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M48.049 45.494h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332zm0 5.06h4.332v-5.06h-4.332zm-4.333 0h4.333v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M39.384 55.613h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M74.044 45.494h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332zm0 5.06h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M74.044 50.554h4.333v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M74.044 55.613h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M13.389 65.732h4.332v-5.06H13.39zm0 5.06h4.332v-5.06H13.39z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M13.389 60.673h4.332v-5.06H13.39z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M22.054 60.673h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M17.721 60.673h4.333v-5.06H17.72zm12.998 5.059h4.332v-5.06H30.72z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M17.721 65.732h4.333v-5.06H17.72zm12.998 5.06h4.332v-5.06H30.72zm-4.333 0h4.333v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M30.719 60.673h4.332v-5.06H30.72zm-4.333 0h4.333v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M26.386 65.732h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332zm0 5.06h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M17.721 70.792h4.333v-5.06H17.72z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M56.714 60.673h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332zm12.998 5.059h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M52.382 65.732h4.332v-5.06h-4.332zm12.998 5.06h4.332v-5.06h-4.333zm-4.333 0h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M65.38 60.673h4.332v-5.06h-4.333zm-4.333 0h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M61.047 65.732h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M56.714 65.732h4.333v-5.06h-4.333zm0 5.06h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M39.384 60.673h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.333zm12.997 5.059h4.333v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M35.052 65.732h4.332v-5.06h-4.333zm12.997 5.06h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M48.049 60.673h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M43.717 65.732h4.332v-5.06h-4.332zm-4.333 0h4.333v-5.06h-4.333zm0 5.06h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M74.044 60.673h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M69.712 65.732h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M74.044 65.732h4.333v-5.06h-4.333zm0 5.06h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M13.389 80.912h4.332v-5.06H13.39z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M13.389 75.852h4.332v-5.06H13.39z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M22.054 75.852h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M17.721 75.852h4.333v-5.06H17.72zm12.998 5.06h4.332v-5.06H30.72zm-12.998 0h4.333v-5.06H17.72z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M30.719 75.852h4.332v-5.06H30.72zm-4.333 0h4.333v-5.06h-4.333zm0 5.06h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M56.714 75.852h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332zm12.998 5.06h4.332v-5.06h-4.333zm-12.998 0h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M65.38 75.852h4.332v-5.06h-4.333zm-4.333 0h4.332v-5.06h-4.333zm0 5.06h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M56.714 80.912h4.333v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M39.384 75.852h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.333zm12.997 5.06h4.333v-5.06h-4.333zm-12.997 0h4.332v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M48.049 75.852h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332zm0 5.06h4.332v-5.06h-4.332zm-4.333 0h4.333v-5.06h-4.333z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffec3d",
					d: "M74.044 75.852h4.333v-5.06h-4.333zm-4.332 0h4.332v-5.06h-4.332zm0 5.06h4.332v-5.06h-4.332z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#251d97",
					d: "M74.044 80.912h4.333v-5.06h-4.333z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fecfc4",
			d: "m33.562 43.536 3.585 3.734-4.723 6.174 2.544 2.648 4.723-6.175 3.574 3.735 2.653-14.88z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6153bd",
			d: "M31.978 43.639a18 18 0 0 0 .02 3.584l2.485-.567c-1.02-.771-1.876-1.803-2.505-3.017M17.603 23.116c.002.173-.025.345-.08.506a1.3 1.3 0 0 1-.241.43 1.1 1.1 0 0 1-.365.287.98.98 0 0 1-.864-.004 1.1 1.1 0 0 1-.363-.29 1.3 1.3 0 0 1-.238-.434 1.5 1.5 0 0 1-.076-.506c.007-.34.128-.664.337-.9.21-.238.49-.37.78-.368.292.001.572.136.779.375.207.24.326.564.331.904M73.57 62.184a167 167 0 0 1-3.098-3.191l.742-1.017zM71.64 44.83l-1.555.08c.263-.184.5-.414.703-.681.26.242.547.444.852.6M38.275 72.903 34.74 74.29l-.336 1.596 8.722-2.52c-2.811-.255-4.84-.475-4.85-.463m49.986.531c-.92.52-1.563.139-1.505-1.121zm3.128-6.094a2.02 2.02 0 0 1-1.425-.543c.673-.37 1.267-.266 1.426.544M74.342 39.164c1.852-.183 1.208 2.648.317 3.688-.168.255-.099.426.436.474 1.118.104.604 1.977-1.178 1.353a.84.84 0 0 0-.475.197c2.396 1.33 3.049 6.139 4.96 1.338 1.9-4.784-1.99-7.316-4.06-7.05m13.208 26.42a.55.55 0 0 1-.128.36.4.4 0 0 1-.307.148.4.4 0 0 1-.308-.148.55.55 0 0 1-.128-.36.55.55 0 0 1 .128-.359.4.4 0 0 1 .308-.149c.115 0 .226.054.307.149a.55.55 0 0 1 .127.36m-6.722-.51a.55.55 0 0 1-.127.359.4.4 0 0 1-.308.149.4.4 0 0 1-.308-.15.55.55 0 0 1-.127-.359.56.56 0 0 1 .127-.359.4.4 0 0 1 .308-.149c.115 0 .226.054.308.15a.55.55 0 0 1 .127.359m-1.168-6.59a.55.55 0 0 1-.128.359.4.4 0 0 1-.307.149.4.4 0 0 1-.308-.149.55.55 0 0 1-.127-.36c0-.134.045-.263.127-.359a.4.4 0 0 1 .308-.148c.115 0 .226.053.307.148a.55.55 0 0 1 .128.36m-6.792 0a.55.55 0 0 1-.127.359.4.4 0 0 1-.308.149.4.4 0 0 1-.307-.149.55.55 0 0 1-.128-.36c0-.134.046-.263.128-.359a.4.4 0 0 1 .307-.148c.116 0 .226.053.308.148a.55.55 0 0 1 .127.36m-.99-7.701a.55.55 0 0 1-.127.359.4.4 0 0 1-.308.149.4.4 0 0 1-.307-.15.55.55 0 0 1-.128-.359c0-.134.046-.264.128-.359a.4.4 0 0 1 .307-.149c.116 0 .226.054.308.15a.55.55 0 0 1 .127.358m-6.019.128a.55.55 0 0 1-.128.36.4.4 0 0 1-.308.148.4.4 0 0 1-.307-.148.55.55 0 0 1-.127-.36c0-.134.045-.264.127-.359a.4.4 0 0 1 .308-.149c.115 0 .226.054.307.15a.55.55 0 0 1 .128.358m-3.206-8.486a.55.55 0 0 1-.128.36.4.4 0 0 1-.307.148.4.4 0 0 1-.308-.149.56.56 0 0 1-.128-.359c0-.135.046-.264.128-.36a.4.4 0 0 1 .308-.148c.115 0 .226.053.307.149a.55.55 0 0 1 .128.36m-6.299.831a.55.55 0 0 1-.127.36.4.4 0 0 1-.308.148.4.4 0 0 1-.308-.149.55.55 0 0 1-.127-.359.56.56 0 0 1 .127-.36.4.4 0 0 1 .308-.148.41.41 0 0 1 .308.149.56.56 0 0 1 .127.36m0-6.511a.55.55 0 0 1-.127.36.4.4 0 0 1-.308.148.4.4 0 0 1-.308-.148.55.55 0 0 1-.127-.36c0-.134.046-.264.127-.359a.4.4 0 0 1 .308-.149c.115 0 .226.054.308.15a.55.55 0 0 1 .127.358m-5.373 1.111a.56.56 0 0 1-.127.359.4.4 0 0 1-.308.149.4.4 0 0 1-.308-.149.55.55 0 0 1-.127-.36.56.56 0 0 1 .127-.359.4.4 0 0 1 .308-.148c.115 0 .226.053.308.148a.56.56 0 0 1 .127.36m-.725-7.122a.6.6 0 0 1-.033.194.5.5 0 0 1-.095.165.4.4 0 0 1-.14.11.38.38 0 0 1-.334 0 .4.4 0 0 1-.141-.11.5.5 0 0 1-.094-.165.58.58 0 0 1 .094-.554.4.4 0 0 1 .308-.149c.115 0 .226.054.307.15a.55.55 0 0 1 .128.359m-5.357.902a.56.56 0 0 1-.127.36.4.4 0 0 1-.308.148.4.4 0 0 1-.308-.149.56.56 0 0 1-.128-.36c0-.134.046-.264.128-.36a.4.4 0 0 1 .308-.148c.115 0 .226.053.308.149a.56.56 0 0 1 .127.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M4.148 62.45a.2.2 0 0 1-.049.14.16.16 0 0 1-.119.057.16.16 0 0 1-.119-.058.2.2 0 0 1-.05-.139c0-.052.018-.102.05-.139a.16.16 0 0 1 .12-.057c.044 0 .087.02.118.058a.2.2 0 0 1 .05.139Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M20.741 69.856h-2.673a6.3 6.3 0 0 1-2.733-.656 7.2 7.2 0 0 1-2.31-1.828 8.6 8.6 0 0 1-1.534-2.724 9.6 9.6 0 0 1-.522-3.202V26.041a9.6 9.6 0 0 1 .578-3.192 8.5 8.5 0 0 1 1.581-2.69 7.2 7.2 0 0 1 2.342-1.778 6.26 6.26 0 0 1 2.747-.595H61.68c1.907.03 3.727.94 5.061 2.533s2.075 3.737 2.059 5.965v18.962m-4.477 24.142c1.3-.635 2.409-1.703 3.19-3.07.783-1.368 1.202-2.974 1.206-4.619v-.313M49.196 27.932h19.622m-57.799-.144h28.345"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M17.603 23.116c.002.173-.025.345-.08.506a1.3 1.3 0 0 1-.241.43 1.1 1.1 0 0 1-.365.287.98.98 0 0 1-.864-.004 1.1 1.1 0 0 1-.363-.29 1.3 1.3 0 0 1-.238-.434 1.5 1.5 0 0 1-.076-.506c.007-.34.128-.664.337-.9.21-.238.49-.37.78-.368.292.001.572.136.779.375.207.24.326.564.331.904m3.357.011a1.5 1.5 0 0 1-.08.506 1.3 1.3 0 0 1-.242.43 1.1 1.1 0 0 1-.366.288.98.98 0 0 1-.864-.004 1.1 1.1 0 0 1-.363-.291 1.4 1.4 0 0 1-.238-.433 1.5 1.5 0 0 1-.076-.507c.007-.34.128-.663.337-.9.21-.238.49-.37.781-.368.292.001.571.136.779.375.207.24.326.564.331.904m3.367.023q-.002.26-.087.498-.087.238-.243.421-.158.182-.362.28a.98.98 0 0 1-.853-.004 1.1 1.1 0 0 1-.36-.284 1.3 1.3 0 0 1-.24-.423 1.5 1.5 0 0 1-.083-.498c.001-.345.12-.675.33-.918s.493-.379.788-.377c.296.001.579.14.787.385.208.244.324.576.323.92m9.236 20.386 3.585 3.734-4.723 6.174 2.544 2.648 4.723-6.175 3.574 3.735 2.653-14.88z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M31.978 43.639a18 18 0 0 0 .02 3.584l2.485-.567c-1.022-.768-1.879-1.8-2.505-3.017M41.77 23.29V.384m-.005 33.613v-3.191m.005 9.561V36.54m-9.772 10.684c.376 3.364 1.782 6.51 4.604 6.51 2.05 0 3.376-1.028 4.178-2.67m2.06-15.796c0 .338-.116.661-.32.9a1.02 1.02 0 0 1-.77.372c-.289 0-.566-.134-.77-.372a1.4 1.4 0 0 1-.32-.9c0-.337.115-.66.32-.9.204-.238.481-.372.77-.372s.566.134.77.373c.204.238.32.562.32.9m-1.04-6.438c1.01-.037 1.098-1.468.118-1.515-.732-.034-1.247-.023-1.823-.023-.97 0-1.02 1.516-.218 1.596.477.044.995-.028 1.922-.058m-.554-4.837c-.356-.023-.614-.035-.95-.06-.92-.061-1.019 1.449-.258 1.572q.581.075 1.165.058m.764 4.895c.98-.073 1.042-1.455.089-1.468-.703-.01-1.208.018-1.762.034-.94.027-.96 1.476-.188 1.538q.933.009 1.86-.104m-.762-4.857c-.376-.011-.701.011-1.067 0-.98-.023-1.059 1.514-.257 1.607.495.058 1.01.013 1.96 0 .141.01.28-.033.4-.122a.76.76 0 0 0 .257-.377.9.9 0 0 0 .014-.481.8.8 0 0 0-.235-.396"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M46.162 25.54a14.5 14.5 0 0 0-1.64-1.881c-.584-.544-.802-.46-2.02-.426-1.425.037-1.302.115-1.296 2.96 0 .693 1.03.832 1.306-1.365-.227 1.688.386 2.88 1.355 3.308M42.305 30.9c-.455-.17-.738-.061-2.177-.334m31.086 27.411 2.356 4.208m13.546 11.34c-7.54-5.664-10.541-8.097-16.644-14.53M66.798 44.02l-4.03 7.215 6.297 5.92 4.812-6.371"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M73.442 44.865c-2.165 2.656-2.183 3.085-.582 4.83 3.977 4.337 4.634 5.124 6.531 6.916 2.079 1.965 5.172 4.649 11.684 10.128m-21-21.829 1.563-.08q-.45-.254-.851-.602"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M74.343 39.153a4.5 4.5 0 0 0-1.594.59c-3.665 2.03-2.842 3.665-1.96 4.486l-.714.682c-.305.23-.659.354-1.022.358a1.7 1.7 0 0 1-1.027-.335c-10.734-7.988-21.2-19.557-21.415-19.818-1.856 1.672-3.39 3.779-4.504 6.186a164 164 0 0 0 19.009 18.627M37.355 62.103a9.07 9.07 0 0 1 5.177-.669l12.495 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "m75.303 52.357-9.119 12.498a17.5 17.5 0 0 1-1.86 4.533c-1.21 2.034-3.09 4.08-5.872 4.486-4.012.586-16.219-.555-20.164-.983l-18.794 7.353c-1.806-2.33-2.783-5.376-2.732-8.519l20.593-9.621.208-1.006c.272-1.27.9-2.398 1.785-3.204s1.974-1.243 3.096-1.242h14.87l7.861-13.903"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "m34.746 74.276-2.345 10.94c2.325 1.642 5.008 2.462 7.723 2.36l3-14.21m50.009.729a10.4 10.4 0 0 0 2.102 2.288c1.574 1.26 1.17 1.717-.365.983-1.071-.511-1.29-.737-3.664-1.989a46 46 0 0 1-4.445-3.063"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M93.59 74.73s1.178.482 2.642.994c1.645.574 2.11-.046.317-1.087a8.4 8.4 0 0 1-2.514-1.977"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M94.42 71.25s3.525 1.388 3.752 1.468c1.702.597 1.555 1.366-.079 1.203-1.495-.15-3.326-.532-3.326-.532m-3.377-6.048a1 1 0 0 0-.315-.602c-.793-.639-2.208.868-2.866 1.83-.773 1.133-2.116 4.164-1.094 4.956a1.02 1.02 0 0 0 1.146-.09"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M89.965 66.797c.73.519 1.796.844 2.345.14.732-.937 1.684-2.43 2.05-2.013.565.647-.98 2.694-.98 3.793 0 .37.842.7 1.198.775.573.121 2.525.541 2.722.578 1.772.323 1.555 1.15.01 1.133a7.2 7.2 0 0 0-2.267.266"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "M94.599 70.302c-.188 1.603-.82 3.09-1.802 4.231m.643-4.07c-.98 1.457-2.119 2.093-3.425 1.434M16.811 73.4c-2.136.974-5.554 2.44-7.475 3.076-2.136.705-3.99 1.433-4.069 1.886-.257 1.619 5.315.913 7.693 2.07.56.283 1.161.44 1.771.46 1.147 0 2.159-1.178 3.97-1.86-1.023-1.664-1.673-3.6-1.89-5.632m16.801 12.58c-.673 2.566-1.713 6.277-2.426 8.312-.841 2.417-1.495 4.568-1.237 4.915.93 1.237 3.89-4.324 6.138-5.793a5 5 0 0 0 1.407-1.338c.683-1.006.554-2.579 1.118-4.544a12.5 12.5 0 0 1-5-1.552m41.095-43.186c.866-1.084 1.453-3.823-.365-3.642 2.07-.254 5.969 2.277 4.06 7.065-1.913 4.797-2.565-.023-4.96-1.353a.55.55 0 0 1 .219-.157.5.5 0 0 1 .256-.025c1.782.624 2.297-1.253 1.178-1.353-.436-.042-.685-.163-.388-.535M7.504 63.341a.7.7 0 0 1 0 .615.6.6 0 0 1-.192.225.47.47 0 0 1-.263.085H.911a.5.5 0 0 1-.263-.084.6.6 0 0 1-.193-.225.7.7 0 0 1 0-.616l3.07-6.22a.6.6 0 0 1 .193-.223.47.47 0 0 1 .524 0c.08.053.147.13.193.223zM3.98 59.236v2.162m51.943 23.183v5.989m2.569-2.995h-5.139m23.575-60.227a.9.9 0 0 0-.683-.329.9.9 0 0 0-.683.329l-.257.29-.238-.29a.9.9 0 0 0-.683-.33.9.9 0 0 0-.683.33 1.23 1.23 0 0 0-.283.798c0 .299.102.586.283.797l1.615 1.887 1.615-1.886c.181-.213.282-.5.282-.799s-.103-.586-.285-.797M31.582 5.958q.117 0 .226.054a.6.6 0 0 1 .19.151q.082.098.126.225a.8.8 0 0 1 .042.264v4.532q0 .137-.046.263a.7.7 0 0 1-.13.222.6.6 0 0 1-.192.147.5.5 0 0 1-.226.05h-5.791a.5.5 0 0 1-.225-.054.6.6 0 0 1-.19-.15.7.7 0 0 1-.127-.226.8.8 0 0 1-.042-.264V6.64q0-.137.046-.263a.7.7 0 0 1 .13-.222.6.6 0 0 1 .192-.147.5.5 0 0 1 .226-.05z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#120071",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .769,
			d: "m25.395 6.12 3.287 2.786 3.286-2.774m36.068 38.803q.786 4.005 4.208 4.035M60.769 66.093a7.96 7.96 0 0 0 .515 4.845m1.208-17.818-2.733 4.44 1.327 3.4 3.227.878 3.228-4.035zM36.978 87.274l1.95-8.81m-21.018-.948 8.208-3.573m8.286 1.931 8.722-2.509"
		})
	]
});
export default SvgThreddGroup;
